/**
 * Parseia o payload do evolutivo de cruzamentos para o formato aceito no evolutivo default. Isso é utilizado atualmente porque
 * a forma como o gráfico evolutivo lida com os dados do evolutivo de cruzamentos é a mesma.
 * @param {array} data Resultados do evolutivo de cruzamentos 
 */
export const parseResultToDefaultEvolutive = function(data) {
  return data.map(({ id_pesquisa, titulo_pesquisa, resultados }) => ({
    idPesquisa: id_pesquisa,
    tituloPesquisa: titulo_pesquisa,
    resultados: resultados.map(({ alternativa_original, resultado_numerico, resultado_percentual, ...rest }) => ({
      ...rest,
      alternativaOriginal: alternativa_original,
      resultadoNumerico: resultado_numerico,
      resultadoPercentual: resultado_percentual,
    }))
  }));
}